import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 mt-24 border-t border-[rgba(76,201,255,0.18)] bg-[rgba(4,6,13,0.7)] backdrop-blur-sm"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 px-6 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-block h-2.5 w-2.5 rotate-45 bg-[var(--neon)] shadow-[0_0_10px_rgba(76,201,255,0.8)]" />
          <span className="font-fantasy text-sm tracking-[0.32em] text-[var(--neon-bright)]">
            ARISE FORGE
          </span>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 font-system text-sm">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="link-neon uppercase tracking-[0.18em]"
          >
            Privacy &amp; Support
          </Link>
          <a
            href="mailto:ariseforgeapp@gmail.com"
            data-testid="footer-email-link"
            className="link-neon uppercase tracking-[0.18em]"
          >
            Contact
          </a>
        </nav>

        <p className="font-system text-xs uppercase tracking-[0.22em] text-[var(--ink-dim)]">
          © {new Date().getFullYear()} Arise Forge — All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
